import { Skeleton } from './ui/skeleton'

const TableSkeleton = () => {
  return (
    <>
      <div className='flex items-center justify-between'>
        <div className='flex items-center w-[30%] gap-2'>
          <Skeleton className="h-12 w-[50%] mb-2" />
          <Skeleton className="h-12 w-[50%] mb-2" />
        </div>
        <div className='flex items-center w-[40%] gap-2'>
          <Skeleton className="h-12 w-[33%] mb-2" />
          <Skeleton className="h-12 w-[33%] mb-2" />
          <Skeleton className="h-12 w-[33%] mb-2" />
        </div>
      </div>
      <Skeleton className="h-12 w-full rounded-b-none bg-primary-5" />
      <Skeleton className="h-12 w-full rounded-none bg-disabled-light-dark border-b" />
      <Skeleton className="h-12 w-full rounded-none bg-disabled-light-dark border-b" />
      <Skeleton className="h-12 w-full rounded-none bg-disabled-light-dark border-b" />
      <Skeleton className="h-12 w-full rounded-none bg-disabled-light-dark border-b" />
      <Skeleton className="h-12 w-full rounded-none bg-disabled-light-dark border-b" />
      <Skeleton className="h-12 w-full rounded-none bg-disabled-light-dark border-b" />
    </>
  )
}

export default TableSkeleton